// extracted by mini-css-extract-plugin
export default {"registrationButtonSpacing":"ENgDsK","registrationButtonSpacing--noImage":"RPTR3a","registrationButtonSpacingNoImage":"RPTR3a"};